import { linkEditing } from '@yola/ws-sdk';

const { linkTypes } = linkEditing.constants;

const isOpenAddress = (type) => type === linkTypes.PATH || type === linkTypes.EXTERNAL;

export default isOpenAddress;
